import { render, staticRenderFns } from "./offer.vue?vue&type=template&id=29894f08&"
import script from "./offer.vue?vue&type=script&lang=ts&"
export * from "./offer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29894f08')) {
      api.createRecord('29894f08', component.options)
    } else {
      api.reload('29894f08', component.options)
    }
    module.hot.accept("./offer.vue?vue&type=template&id=29894f08&", function () {
      api.rerender('29894f08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/offer.vue"
export default component.exports